import { Box } from "@chakra-ui/react";

export interface PodcastNewsBriefProps {
  link: string;
}

export const PodcastNewsBrief = ({ link }: PodcastNewsBriefProps) => {
  return (
    <>
      <Box
        as="iframe"
        src={link}
        width="100%"
        height="180"
        frameBorder="no"
        scrolling="no"
        seamless
      />
    </>
  );
};
